// extracted by mini-css-extract-plugin
module.exports = {"redlMsg":"bubbleMsg_redlMsg__3IhjZ","redlMsgWrapper":"bubbleMsg_redlMsgWrapper__m__8O","redlMsgHeader":"bubbleMsg_redlMsgHeader__qBfB_"};